"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _excluded = ["title", "titleId"];
var SvgSpecies2 = function SvgSpecies2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 200 128",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F4FF",
    fillRule: "evenodd",
    d: "M85.957 4.231c27.911-2.327 55.85 13.068 64.879 39.58 9.385 27.56-1.432 58.971-25.993 74.602-21.169 13.473-47.12.371-66.2-15.926-14.37-12.272-16.13-31.86-11.069-50.066C53.656 30.547 63.332 6.117 85.958 4.23Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#species2_svg__a)",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M85.957 4.231c27.911-2.327 55.85 13.068 64.879 39.58 9.385 27.56-1.432 58.971-25.993 74.602-21.169 13.473-47.12.371-66.2-15.926-14.37-12.272-16.13-31.86-11.069-50.066C53.656 30.547 63.332 6.117 85.958 4.23Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "species2_svg__c",
    width: 110,
    height: 120,
    x: 45,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'alpha'
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F4FF",
    fillRule: "evenodd",
    d: "M85.957 4.231c27.911-2.327 55.85 13.068 64.879 39.58 9.385 27.56-1.432 58.971-25.993 74.602-21.169 13.473-47.12.371-66.2-15.926-14.37-12.272-16.13-31.86-11.069-50.066C53.656 30.547 63.332 6.117 85.958 4.23Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#species2_svg__b)",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M85.957 4.231c27.911-2.327 55.85 13.068 64.879 39.58 9.385 27.56-1.432 58.971-25.993 74.602-21.169 13.473-47.12.371-66.2-15.926-14.37-12.272-16.13-31.86-11.069-50.066C53.656 30.547 63.332 6.117 85.958 4.23Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#species2_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#species2_svg__d)",
    d: "M82.573 37.063c-2.593 0-4.74 2.146-4.74 4.74v8.124c0 1.321.557 2.526 1.446 3.39C80.136 54.15 87 61 87 61l2.5 1-3.54 20.427c0 1.275.518 2.442 1.354 3.299C88.177 86.612 129 127 129 127l26.187-1.448v2.031c0 2.593 2.147 4.74 4.74 4.74h10.833c2.594 0 4.74-2.147 4.74-4.74l-54.333-46.51c0-2.593-2.147-4.74-4.74-4.74l52.792 49.896c-2.593 0-4.74 2.147-4.74 4.74V133h-10.156c-.4 0-.677-.278-.677-.677l18.854-2.232-8.021-14.695-6.792-6.948c0 2.593 2.147 4.739 4.74 4.739h10.833c2.594 0 4.74-2.146 4.74-4.739l-28.5-22.722S120.725 57.146 120 56.31a4.738 4.738 0 0 0-3.573-1.644h-10.833c-2.594 0-4.74 2.146-4.74 4.74v2.03H90.021l72.427 51.75 11.489 16.167c2.594 0 1.063-17.636 1.063-20.229L117 58.5S97.712 39.562 97 38.731a4.74 4.74 0 0 0-3.594-1.669H82.573Zm0 4.062h10.833c.4 0 .677.278.677.677v8.125c0 .4-.277.677-.677.677h-5.083a2.027 2.027 0 0 0-.659 0h-5.091c-.4 0-.677-.277-.677-.677v-8.125c0-.4.277-.677.677-.677Zm23.021 17.604L117 58.5s.104.507.104.906l56.833 49.042c0 .399-.277.677-.677.677h-10.833c-.4 0-.677-.278-.677-.677l6.792 5.25c.035-.218-63.59-50.336-63.625-50.555v-3.737c0-.4.277-.677.677-.677Zm48.729 66.948h10.833c.4 0 .677.278.677.677l5.604 1.229c0 .4-.277.677-.677.677h-10.833c-.4 0-.677-.277-.677-.677v-3.729c.036-.218-5.568 6.455-5.604 6.237v-3.737c0-.399.277-.677.677-.677Z",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#species2_svg__e)",
    d: "M149.999 67.449h-.019c-2.75 0-4.982-3.33-5-7.449-.018 4.11-2.239 7.434-4.98 7.449 2.741.015 4.962 3.34 4.98 7.449.018-4.119 2.25-7.449 5-7.449h.019Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#species2_svg__f)",
    d: "M75.999 24.449h-.02c-2.75 0-4.98-3.33-4.999-7.449-.018 4.11-2.239 7.434-4.98 7.449 2.741.015 4.962 3.34 4.98 7.449.018-4.119 2.25-7.449 5-7.449h.019Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#species2_svg__g)",
    d: "M69.999 104.449h-.02c-2.75 0-4.98-3.33-4.999-7.449-.018 4.109-2.239 7.434-4.98 7.449 2.741.015 4.962 3.34 4.98 7.449.018-4.119 2.25-7.449 5-7.449h.019Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F4FF",
    d: "M82.573 41.125h10.833c.4 0 .677.278.677.677v8.125c0 .4-.277.677-.677.677h-5.083a2.027 2.027 0 0 0-.659 0h-5.091c-.4 0-.677-.277-.677-.677v-8.125c0-.4.277-.677.677-.677Zm23.021 17.604h10.833c.4 0 .677.278.677.677v8.125c0 .4-.277.677-.677.677h-10.833c-.4 0-.677-.277-.677-.677v-3.729c.035-.218.035-.44 0-.659v-3.737c0-.4.277-.677.677-.677Zm0 21.667h10.833c.4 0 .677.277.677.677v8.125c0 .4-.277.677-.677.677h-10.833c-.4 0-.677-.278-.677-.677v-3.73c.035-.217.035-.44 0-.658v-3.737c0-.4.277-.677.677-.677Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C8658",
    d: "M82.573 37.063c-2.593 0-4.74 2.146-4.74 4.74v8.124c0 2.593 2.147 4.74 4.74 4.74h3.385v27.76c0 2.593 2.147 4.74 4.74 4.74h10.156v2.03c0 2.594 2.146 4.74 4.74 4.74h10.833c2.593 0 4.74-2.146 4.74-4.74v-8.124c0-2.593-2.147-4.74-4.74-4.74h-10.833c-2.594 0-4.74 2.147-4.74 4.74v2.031H90.698c-.4 0-.677-.277-.677-.677V65.5h10.833v2.031c0 2.593 2.146 4.74 4.74 4.74h10.833c2.593 0 4.74-2.147 4.74-4.74v-8.125c0-2.593-2.147-4.74-4.74-4.74h-10.833c-2.594 0-4.74 2.147-4.74 4.74v2.032H90.021v-6.771h3.385c2.593 0 4.74-2.147 4.74-4.74v-8.125c0-2.593-2.147-4.74-4.74-4.74H82.573Zm0 4.062h10.833c.4 0 .677.278.677.677v8.125c0 .4-.277.677-.677.677h-5.083a2.027 2.027 0 0 0-.659 0h-5.091c-.4 0-.677-.277-.677-.677v-8.125c0-.4.277-.677.677-.677Zm23.021 17.604h10.833c.4 0 .677.278.677.677v8.125c0 .4-.277.677-.677.677h-10.833c-.4 0-.677-.277-.677-.677v-3.729c.035-.218.035-.44 0-.659v-3.737c0-.4.277-.677.677-.677Zm0 21.667h10.833c.4 0 .677.277.677.677v8.125c0 .4-.277.677-.677.677h-10.833c-.4 0-.677-.278-.677-.677v-3.73c.035-.217.035-.44 0-.658v-3.737c0-.4.277-.677.677-.677Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "species2_svg__a",
    x1: 125.711,
    x2: 74.42,
    y1: 104,
    y2: 4.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53EA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "species2_svg__b",
    x1: 125.711,
    x2: 74.42,
    y1: 104,
    y2: 4.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53EA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "species2_svg__d",
    x1: 77.772,
    x2: 87.37,
    y1: 37.091,
    y2: 45.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#308F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "species2_svg__e",
    x1: 140,
    x2: 150,
    y1: 60,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#308F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "species2_svg__f",
    x1: 66,
    x2: 76,
    y1: 17,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#308F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "species2_svg__g",
    x1: 60,
    x2: 70,
    y1: 97,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#308F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DF2"
  }))));
};
var _default = SvgSpecies2;
exports.default = _default;